// // src/context/AuthContext.js
// import React, { createContext, useState, useEffect, useContext } from 'react';
// import { jwtDecode } from 'jwt-decode';
// import { verifyToken as verifyTokenAPI, getUsers } from '../services/api';

// export const AuthContext = createContext();

// export const AuthProvider = ({ children }) => {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   // Handle login and persist token
//   const login = async (token) => {
//     try {
//       localStorage.setItem('token', token);
//       const decoded = jwtDecode(token);
      
//       // Get all users and find the current one
//       const usersData = await getUsers();
//       const currentUser = usersData.find(user => user.id === decoded.id);
      
//       if (currentUser) {
//         const fullUser = {
//           ...decoded,
//           username: currentUser.username,
//           email: currentUser.email,
//           role: currentUser.role
//         };
//         setUser(fullUser);
//       } else {
//         // Fallback to basic token data if user not found
//         setUser(decoded);
//       }
//     } catch (err) {
//       console.error('Invalid token', err);
//       logout();
//     }
//   };

//   // Handle logout
//   const logout = () => {
//     localStorage.removeItem('token');
//     setUser(null);
//   };

//   // Initialize auth on mount
//   useEffect(() => {
//     const initializeAuth = async () => {
//       const token = localStorage.getItem('token');

//       if (!token) {
//         setUser(null);
//         setLoading(false);
//         return;
//       }

//       try {
//         const result = await verifyTokenAPI();
//         if (result?.success) {
//           const decoded = jwtDecode(token);
//           // Get all users and find the current one
//           const usersData = await getUsers();
//           const currentUser = usersData.find(user => user.id === decoded.id);
          
//           if (currentUser) {
//             const fullUser = {
//               ...decoded,
//               username: currentUser.username,
//               email: currentUser.email,
//               role: currentUser.role
//             };
//             setUser(fullUser);
//           } else {
//             // Fallback to basic token data if user not found
//             setUser(decoded);
//           }
//         } else {
//           logout();
//         }
//       } catch (err) {
//         console.error('Token verification failed:', err);
//         logout();
//       } finally {
//         setLoading(false);
//       }
//     };

//     initializeAuth();
//   }, []);

//   return (
//     <AuthContext.Provider value={{ user, login, logout, loading }}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// export const useAuth = () => useContext(AuthContext);
// src/context/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { jwtDecode } from 'jwt-decode';
import { verifyToken as verifyTokenAPI, getUsers, logoutAPI } from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Handle login and persist token
  const login = async (token) => {
    try {
      localStorage.setItem('token', token);
      const decoded = jwtDecode(token);
      
      const usersData = await getUsers();
      const currentUser = usersData.find(user => user.id === decoded.id);
      
      if (currentUser) {
        const fullUser = {
          ...decoded,
          username: currentUser.username,
          email: currentUser.email,
          role: currentUser.role
        };
        setUser(fullUser);
      } else {
        setUser(decoded);
      }
    } catch (err) {
      console.error('Invalid token', err);
      logout();
    }
  };

  // Enhanced logout function
  const logout = async () => {
    try {
      // Call the backend logout API first
      await logoutAPI();
      console.log("HELLO")
    } catch (err) {
      console.error('Logout API error:', err);
      // Even if the API call fails, proceed with client-side cleanup
    } finally {
      // Client-side cleanup
      localStorage.removeItem('token');
      setUser(null);
      // Redirect to login page
      window.location.href = '/login';
    }
  };

  // Initialize auth on mount
  useEffect(() => {
    const initializeAuth = async () => {
      const token = localStorage.getItem('token');

      if (!token) {
        setUser(null);
        setLoading(false);
        return;
      }

      try {
        const result = await verifyTokenAPI();
        if (result?.success) {
          const decoded = jwtDecode(token);
          const usersData = await getUsers();
          const currentUser = usersData.find(user => user.id === decoded.id);
          
          if (currentUser) {
            const fullUser = {
              ...decoded,
              username: currentUser.username,
              email: currentUser.email,
              role: currentUser.role
            };
            setUser(fullUser);
          } else {
            setUser(decoded);
          }
        } else {
          logout();
        }
      } catch (err) {
        console.error('Token verification failed:', err);
        logout();
      } finally {
        setLoading(false);
      }
    };

    initializeAuth();
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);